/**
 * List of states
 * @public
 */
export enum HoruzProtocolChulakServiceState {
  'AgentStart' = 1,
  'AppPairing' = 2,
  'AppPresentation' = 3,
  'Done' = 4,
  'Abort' = 5,
}

/**
 * List of states common states between client and server
 * @public
 */
export enum HoruzProtocolChulakLastState {
  AgentStart = 'AgentStart',
  AppPairing = 'AppPairing',
  AppPresentation = 'AppPresentation',
  Done = 'Done',
  Abort = 'Abort',
}

/**
 * Statemap
 * @public
 */
export type HoruzProtocolChulakServiceStateKey =
  keyof typeof HoruzProtocolChulakServiceState;
